<div
    cdkScrollable
    class="inset-0 min-w-0 text-center overflow-auto print:overflow-visible select-none" style="height: 100%">

    <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openAccountsManager()">{{ 'Ecommerce.POS.manage_accounts' | transloco }}</button>
        <button mat-menu-item (click)="showQrCode()">{{ 'Ecommerce.POS.see_qr_code' | transloco }}</button>
    </mat-menu>

    <!-- Main -->
    <div class="inline-block text-left print:p-0 main">

        <!-- Invoice -->
        <div class="invoice-wrapper rounded-2xl bg-card print:w-auto print:bg-transparent">
            <div style="display: flex;flex-direction: column; width: 100%;">
                <div class="header" *ngIf="isRestaurant">
                    <div class="order col-span-10 self-center text-2xl font-medium tracking-tight text-secondary">
                        <div>{{ 'Ecommerce.POS.request' | transloco }}</div>
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="menu"
                            *ngIf="!isMobileResolution && isAdmin"
                            [tabIndex]="-1">
                            <mat-icon
                                class="text-current"
                                [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
                        </button>
                        <div *ngIf="isMobileResolution" class="flex items-center">
                            <app-print-receipt-button
                                [buttonId]="'order-list-print-receipt-button'"
                                [color]="'primary'"
                                [label]="''"
                                [icon]="'heroicons_outline:printer'"
                                (print)="printReceipt()">
                            </app-print-receipt-button>
                            <button
                                mat-icon-button
                                (click)="closeModal()"
                                [tabIndex]="-1">
                                <mat-icon
                                    class="text-current"
                                    [svgIcon]="'heroicons_outline:x'"></mat-icon>
                            </button>
                        </div>

                    </div>
                </div>

                <div class="bottom">
                    <div class="container">
                        <div *ngIf="canShowCenas" cdkDropList
                             (cdkDropListEntered)="showEmpty = true"
                             (cdkDropListExited)="showEmpty = false"
                             (cdkDropListDropped)="onDropProductAdd($event); showEmpty = false">
                            <div class="empty" *ngIf="!showEmpty">
                                <mat-icon class="icon-size-12">note_add</mat-icon>
                                <span>{{ "Ecommerce.POS.empty_list" | transloco }}</span>
                            </div>
                        </div>

                        <div class="container-item" *ngFor="let order of ordersAndItemsWithTotal">
                            <div *ngIf="order.name && ordersAndItemsWithTotal.length > 1"
                                 class="tracking-tight text-secondary"
                                 style="margin-bottom: 20px">
                                {{ order.name }}:
                            </div>
                            <div *ngIf="!order.items?.length" cdkDropList
                                 (cdkDropListDropped)="onDropProduct($event, order)">
                                <div class="empty-message">
                                    Sem items
                                </div>
                            </div>
                            <div cdkDropList (cdkDropListDropped)="onDropProduct($event, order)"
                                 *ngFor="let item of order.items?.slice().reverse(); let i = index; let count = count">
                                <div class="item" cdkDrag [cdkDragStartDelay]="100"
                                     [cdkDragData]="{item, deletable: true}"
                                     (cdkDragStarted)="isDragging = true"
                                     (cdkDragEnded)="isDragging = false">
                                    <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                                    <!-- Item -->
                                    <button *ngIf="!isViewOnly" mat-icon-button
                                            (click)="removeQuantityFromItem(item)">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                    <div class="quantity" (click)="openEditProduct(item)">{{ item.quantity }}</div>
                                    <button *ngIf="!isViewOnly" mat-icon-button
                                            (click)="addQuantityToItem(item)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                    <div class="name" (click)="openEditProduct(item)"><b>{{ item.product.name }}</b>
                                    </div>
                                    <!--                                    <div class="price-single">{{ item.preco | currency }}</div>-->
                                    <div class="price-total">{{ item.total | currency }}</div>
                                    <button color="warn" *ngIf="isMobileResolution && !isViewOnly" mat-button
                                            aria-label="Delete item" (click)="promptDeleteItem(item.id)">
                                        <mat-icon style="font-size: 20px">delete</mat-icon>
                                    </button>
                                </div>

                                <!-- Divider -->
                                <div
                                    *ngIf="i !== count - 1 && count > 1"
                                    class="col-span-12 my-4 border-b">
                                </div>
                            </div>
                            <div class="order-total" *ngIf="ordersAndItemsWithTotal.length > 1">
                                <span>Total: </span> <span>{{ order.total | currency }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="total-bottom" *ngIf="ordersAndItemsWithTotal?.length">
                        <!-- Total -->
                        <div style="display:flex; flex-direction: row; justify-content: space-between">
                            <div class="col-span-10 self-center text-2xl font-medium tracking-tight text-secondary">
                                TOTAL
                            </div>
                            <button mat-flat-button color="primary" *ngIf="!isViewOnly" (click)="startPayment()"
                                    [disabled]="!orderHasItems()"
                            >
                                <span style="margin-right: 5px">{{ 'Ecommerce.POS.finish_sell' | transloco }} </span>
                                {{ orderTotal | currency }}
                            </button>
                            <div *ngIf="isViewOnly">
                                {{ orderTotal | currency }}
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>

</div>

<div
    class="delete-zone"
    cdkDropList
    *ngIf="!isMobileResolution"
    [cdkDropListEnterPredicate]="canEnterDeleteZone"
    (cdkDropListDropped)="deleteProduct($event.item.data)"
>
    <div
        class="delete-zone-item">
        <mat-icon>delete</mat-icon>
    </div>
</div>
